import { ThemedComponentProps } from '../theme.types'
import { BaseColor, themeColor } from '../palette'

export const textColor = (props: ThemedComponentProps) => themeColor(BaseColor.shade_80)(props)

export const textHighlightColor = (props: ThemedComponentProps) => themeColor(BaseColor.shade_100)(props)

export const backgroundColor = (props: ThemedComponentProps) => themeColor(BaseColor.shade_10)(props)

export const borderColor = (props: ThemedComponentProps) => themeColor(BaseColor.shade_30)(props)
